/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializes mobile device instance for frontend usage.
 * @export
 * @interface MobileDevice
 */
export interface MobileDevice {
    /**
     * 
     * @type {string}
     * @memberof MobileDevice
     */
    readonly deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof MobileDevice
     */
    readonly deviceName: string;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDevice
     */
    readonly isActive: boolean;
    /**
     * 
     * @type {any}
     * @memberof MobileDevice
     */
    readonly publicKey: any | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDevice
     */
    readonly user: number | null;
    /**
     * Returns a hash of the public key, following RFC7638.
     * @type {string}
     * @memberof MobileDevice
     */
    readonly publicKeyHash: string;
    /**
     * 
     * @type {Date}
     * @memberof MobileDevice
     */
    readonly lastAuthorizedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MobileDevice
     */
    readonly lastUsedAt: Date | null;
}

/**
 * Check if a given object implements the MobileDevice interface.
 */
export function instanceOfMobileDevice(value: object): value is MobileDevice {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    if ((!('deviceName' in (value as Record<string, any>)) && !('device_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceName'] === undefined && (value as Record<string, any>)['device_name'] === undefined)) return false;
    if ((!('isActive' in (value as Record<string, any>)) && !('is_active' in (value as Record<string, any>))) || ((value as Record<string, any>)['isActive'] === undefined && (value as Record<string, any>)['is_active'] === undefined)) return false;
    if ((!('publicKey' in (value as Record<string, any>)) && !('public_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['publicKey'] === undefined && (value as Record<string, any>)['public_key'] === undefined)) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if ((!('publicKeyHash' in (value as Record<string, any>)) && !('public_key_hash' in (value as Record<string, any>))) || ((value as Record<string, any>)['publicKeyHash'] === undefined && (value as Record<string, any>)['public_key_hash'] === undefined)) return false;
    if ((!('lastAuthorizedAt' in (value as Record<string, any>)) && !('last_authorized_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastAuthorizedAt'] === undefined && (value as Record<string, any>)['last_authorized_at'] === undefined)) return false;
    if ((!('lastUsedAt' in (value as Record<string, any>)) && !('last_used_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastUsedAt'] === undefined && (value as Record<string, any>)['last_used_at'] === undefined)) return false;
    return true;
}

export function MobileDeviceFromJSON(json: any): MobileDevice {
    return MobileDeviceFromJSONTyped(json, false);
}

export function MobileDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
        'deviceName': json['device_name'],
        'isActive': json['is_active'],
        'publicKey': json['public_key'],
        'user': json['user'],
        'publicKeyHash': json['public_key_hash'],
        'lastAuthorizedAt': (json['last_authorized_at'] == null ? null : new Date(json['last_authorized_at'])),
        'lastUsedAt': (json['last_used_at'] == null ? null : new Date(json['last_used_at'])),
    };
}

export function MobileDeviceToJSON(json: any): MobileDevice {
    return MobileDeviceToJSONTyped(json, false);
}

export function MobileDeviceToJSONTyped(value?: Omit<MobileDevice, 'deviceId'|'deviceName'|'isActive'|'publicKey'|'user'|'publicKeyHash'|'lastAuthorizedAt'|'lastUsedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

